import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function PlantMetadataForm({ onSave, onCancel }) {
    const [formData, setFormData] = useState({
        name: '',
        species: '',
        health: 'good',
        growthStage: 'growing',
        notes: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.name.trim()) {
            onSave(formData);
        }
    };

    const healthOptions = [
        { value: 'excellent', label: 'Excellent', color: '#4CAF50' },
        { value: 'good', label: 'Good', color: '#FF9800' },
        { value: 'warning', label: 'Warning', color: '#F44336' },
        { value: 'critical', label: 'Critical', color: '#9C27B0' }
    ];

    const growthStageOptions = [
        { value: 'seedling', label: 'Seedling' },
        { value: 'growing', label: 'Growing' },
        { value: 'mature', label: 'Mature' },
        { value: 'flowering', label: 'Flowering' },
        { value: 'dormant', label: 'Dormant' }
    ];

    return (
        <div className="plant-metadata-modal-overlay">
            <div className="plant-metadata-modal">
                <div className="modal-header">
                    <h3>Add Plant Information</h3>
                    <button 
                        className="modal-close-btn"
                        onClick={onCancel}
                        type="button"
                    >
                        <i className="ri-close-line"></i>
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="plant-metadata-form">
                    <div className="form-group">
                        <label htmlFor="name">Plant Name *</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            placeholder="e.g., Monstera Deliciosa"
                            required
                            autoFocus
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="species">Species</label>
                        <input
                            type="text"
                            id="species"
                            name="species"
                            value={formData.species}
                            onChange={handleInputChange}
                            placeholder="e.g., Monstera deliciosa"
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="health">Health Status</label>
                            <select
                                id="health"
                                name="health"
                                value={formData.health}
                                onChange={handleInputChange}
                                className="health-select"
                            >
                                {healthOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                            <div 
                                className="health-indicator"
                                style={{ 
                                    backgroundColor: healthOptions.find(h => h.value === formData.health)?.color 
                                }}
                            ></div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="growthStage">Growth Stage</label>
                            <select
                                id="growthStage"
                                name="growthStage"
                                value={formData.growthStage}
                                onChange={handleInputChange}
                            >
                                {growthStageOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="notes">Notes</label>
                        <textarea
                            id="notes"
                            name="notes"
                            value={formData.notes}
                            onChange={handleInputChange}
                            placeholder="Any observations or care notes..."
                            rows={3}
                        />
                    </div>

                    <div className="form-actions">
                        <button type="button" onClick={onCancel} className="btn-secondary">
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            className="btn-primary"
                            disabled={!formData.name.trim()}
                        >
                            <i className="ri-save-line"></i>
                            Save Plant
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

PlantMetadataForm.propTypes = {
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};
